/* eslint-disable no-unused-vars */
import Checkbox from "@material-ui/core/Checkbox";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import * as React from "react";
import NumberFormat from 'react-number-format';
/* eslint-enable no-unused-vars */

const CommonValues = {
  elementSize: (props) => props.options.padding === "default" ? "medium" : "small",
  baseIconSize: (props) => CommonValues.elementSize(props) === "medium" ? 48 : 32,
  rowActions: (props) => props.actions.filter((a) => a.position === "row" || typeof a === "function"),
  actionsColumnWidth: (props) => CommonValues.rowActions(props).length * CommonValues.baseIconSize(props),
  selectionMaxWidth: (props, maxTreeLevel) => CommonValues.baseIconSize(props) + 9 * maxTreeLevel,
}
export const reducePercentsInCalc = (calc, fullValue) => {
  const captureGroups = calc.match(/(\d*)%/);
  if (captureGroups && captureGroups.length > 1) {
    const percentage = captureGroups[1];
    return calc.replace(/\d*%/, `${fullValue * (percentage / 100)}px`);
  }
  return calc.replace(/\d*%/, `${fullValue}px`);
};

export default class MaterialTableSummaryRow extends React.Component {

  constructor() {
    super();

    this.summaryRowData = {};
  }

  getFieldValue(columnDef) {
    const id = columnDef.tableData.id;
    if (columnDef.summarise && this.summaryRowData[id] !== undefined) {
      return this.summaryRowData[id];
    } 
    return undefined;
  }

  safeAdd (total, amount, precision) {
    function getPrecision(number) {
      const numberString = `${number}`;
      var pieces = numberString.toString().split(".");
      if(!pieces[1]) return 0;
      return pieces[1].length;
    }
    if (typeof amount !== 'number') throw new Error("safeAdd requires a number");
    let v1p = getPrecision(total);
    let v2p = getPrecision(amount);
    const places = (precision || v1p > v2p?v1p:v2p);
    const newTotal = +(Math.round((total + amount) + "e+" + places)  + "e-" + places);
//    console.log(total, amount, v1p, v2p, places, newTotal);
    return newTotal;
  }
  
  summaryRenderer(columnDef) {
    const numberFormatProps = {
      isNumericString: false,
      thousandSeparator: ',',
      decimalSeparator: '.',
      thousandsGroupStyle: 'thousand',
      displayType: 'text', //can also be text to make readonly render
      decimalScale: undefined, //number of decimal places
      fixedDecimalScale: false, // show the trailing zeroes
      value: null,
      defaultValue: null,
      type: 'text', //tel or password supported
      format: undefined, //can use # where a number is to be entered.
      mask: '',
      prefix: undefined,
      suffix: undefined,
      readOnly: true,
      ...columnDef.summariseProps
    }

    if (columnDef.summarise) {
      return (rowData) => {
        return (
          <NumberFormat 
            {...numberFormatProps}
            value={rowData[columnDef.tableData.id]}
          />
        )
      }
    }
    return ()=>(<></>)
  }

  componentDidUpdate(oldProps) {
    if (this.props.data && oldProps.data !== this.props.data) {
      const filteredColumns = this.props.columns.filter(columnDef => columnDef.summarise !== undefined);
      const summaryRowData = {};
      filteredColumns.forEach(columnDef => {
        summaryRowData[columnDef.tableData.id] = 0;
        if (columnDef.field) {
          summaryRowData[columnDef.field] = 0;
        }
      });
      this.props.data.forEach((rowData) => {
        filteredColumns.forEach(columnDef => {
          const fieldValueUnparsed = typeof rowData[columnDef.field] === "string" ? rowData[columnDef.field].replace(/,/g, '') : rowData[columnDef.field];
          const fieldValue = parseFloat(fieldValueUnparsed);

          if (typeof columnDef.summarise === 'function') {
            const summariseResponse = columnDef.summarise(rowData);
            if (summariseResponse === true) {
              if (!isNaN(fieldValue)) {
                summaryRowData[columnDef.tableData.id] = this.safeAdd(summaryRowData[columnDef.tableData.id], fieldValue);
                if (columnDef.field) {
                  summaryRowData[columnDef.field] = this.safeAdd(summaryRowData[columnDef.field], fieldValue);
                }
              }  
            } else {
              if (typeof summariseResponse === 'number') {
                if (!isNaN(summariseResponse)) {
                  summaryRowData[columnDef.tableData.id] = this.safeAdd(summaryRowData[columnDef.tableData.id], summariseResponse);
                  if (columnDef.field) {
                    summaryRowData[columnDef.field] = this.safeAdd(summaryRowData[columnDef.field], summariseResponse);
                  }
                }
              }  
            }
          } else {
            if (!isNaN(fieldValue)) {
              summaryRowData[columnDef.tableData.id] = this.safeAdd(summaryRowData[columnDef.tableData.id], fieldValue);
              if (columnDef.field) {
                summaryRowData[columnDef.field] = this.safeAdd(summaryRowData[columnDef.field], fieldValue);
              }
            }
          }
        });  
      });
      this.summaryRowData = summaryRowData;
    }
  }
  renderColumns() {
    const size = CommonValues.elementSize(this.props);
    const mapArr = this.props.columns
      .filter(
        (columnDef) =>
          !columnDef.hidden && !(columnDef.tableData.groupOrder > -1)
      )
      .sort((a, b) => a.tableData.columnOrder - b.tableData.columnOrder)
      .map((columnDef, index) => {
        const value = this.getFieldValue(columnDef);
        return (
          <this.props.components.Cell
            size={size}
            icons={this.props.icons}
            columnDef={{
              ...columnDef,
              cellStyle: this.props.options.summaryCellStyle || columnDef.cellStyle,
              render: typeof columnDef.summaryRender === "function"? columnDef.summaryRender : this.summaryRenderer(columnDef),
            }}
            value={value}
            key={
              "summaryCell" +
              "-" +
              columnDef.tableData.id
            }
            rowData={{...this.summaryRowData, tableData: {}}}
            cellEditable={false}
            scrollWidth={this.props.scrollWidth}
          />
        );
      });
    return mapArr;
  }

  renderActions() {
    const size = CommonValues.elementSize(this.props);
    const actions = CommonValues.rowActions(this.props);
    const width = actions.length * CommonValues.baseIconSize(this.props);
    return (
      <TableCell
        size={size}
        padding="none"
        key="key-actions-column"
        style={{
          width: width,
          padding: "0px 5px",
          boxSizing: "border-box",
          ...this.props.options.actionsCellStyle,
        }}
      >
        <div style={{ display: "flex" }}>
        </div>
      </TableCell>
    );
  }

  renderSelectionColumn() {
    let checkboxProps = this.props.options.selectionProps || {};
    if (typeof checkboxProps === "function") {
      checkboxProps = checkboxProps(this.props.data);
    }

    const size = CommonValues.elementSize(this.props);
    const selectionWidth = CommonValues.selectionMaxWidth(
      this.props,
      this.props.treeDataMaxLevel
    );

    return (
      <TableCell
        size={size}
        padding="none"
        key="key-selection-column"
        style={{ width: selectionWidth }}
      >
      </TableCell>
    );
  }

  render() {
    // const size = CommonValues.elementSize(this.props);
    const renderColumns = this.renderColumns();
    if (this.props.options.selection) {
      renderColumns.splice(0, 0, this.renderSelectionColumn());
    }
    if (
      this.props.actions &&
      this.props.actions.filter(
        (a) => a.position === "row" || typeof a === "function"
      ).length > 0
    ) {
      if (this.props.options.actionsColumnIndex === -1) {
        renderColumns.push(this.renderActions());
      } else if (this.props.options.actionsColumnIndex >= 0) {
        let endPos = 0;
        if (this.props.options.selection) {
          endPos = 1;
        }
        renderColumns.splice(
          this.props.options.actionsColumnIndex + endPos,
          0,
          this.renderActions()
        );
      }
    }


    const {
      icons,
      data,
      columns,
      components,
      options,
      localization,
      style,
      ...rowProps
    } = this.props;

    if (!this.props?.data?.length) {
      return (<></>);
    }
    return (
      <>
        <TableRow 
          {...rowProps}
          style={{...style}} //
        >
          {renderColumns}
        </TableRow>
      </>
    );
  }
}

MaterialTableSummaryRow.defaultProps = {
  actions: [],
  index: 0,
  data: {},
  options: {},
  path: [],
};
